<template>
  <div class="container">
    <div class="item"><label>原邮箱：</label><el-input placeholder="请输入原邮箱" v-model="oldEmail"></el-input></div>
    <div class="item">
      <label>新邮箱：</label>
      <div class="flex newPhone">
        <el-input placeholder="请输入新邮箱" v-model="newEmail"></el-input>
      </div>
    </div>
    <el-button type="primary" @click="saveBindPhone">提交</el-button>
  </div>
</template>

<script>
export default {
  name: "ChangePhone",
  data() {
    return {
      newEmail: "",
      oldEmail: "",
      yuanEmail: "",
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.yuanEmail = res.data.email;
        this.oldEmail = res.data.email;
      });
    },
    validateEmail(email) {
      var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailRegex.test(email);
    },
    saveBindPhone() {
      if (!this.oldEmail) {
        this.$message.error("请输入原邮箱");
        return;
      }
      if (this.oldEmail != this.yuanEmail) {
        this.$message.error("原邮箱不正确");
        return;
      }
      if (!this.newEmail) {
        this.$message.error("请输入新邮箱");
        return;
      }
      if (!this.validateEmail(this.newEmail)) {
        this.$message.error("新邮箱格式不正确");
        return;
      }

      let postBody = {
        oldMail: this.oldEmail,
        newMail: this.newEmail,
      };
      this.$http({
        url: "api/v1/user/change/mail",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.oldEmail = "";
          this.newEmail = "";
          this.$emit("childByEmail", res.code);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
  padding-left: 40px;
  .item {
    display: flex;
    align-items: center;
    font-size: 14px;
    width: 440px;
    margin-bottom: 15px;
    label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
    ::v-deep .el-input {
      flex: 1;
    }
    .newPhone {
      align-items: center;
      position: relative;
      flex: 1;
      .code {
        position: absolute;
        right: 0;
        padding: 0 20px;
        color: #2d8cf0;
        top: 0;
        line-height: 40px;
        cursor: pointer;
        &::after {
          position: absolute;
          left: 0;
          width: 1px;
          height: 20px;
          background: #eee;
          content: "";
          top: 10px;
        }
      }
    }
  }
  .el-button {
    margin-left: 80px;
  }
}
</style>
